export type CalendarMode = 'list' | 'calendar';

export type EventType = 'all' | 'recordUpdates' | 'visits' | 'collaboration' | 'profile';

export const allEventTypes: EventType[] = ['all', 'recordUpdates', 'visits', 'collaboration', 'profile'] as const;

export type NonAllEventType = Exclude<EventType, 'all'>;

export const nonAllEventTypes: NonAllEventType[] = ['recordUpdates', 'visits', 'collaboration', 'profile'] as const;

export type AuditLogEventType = Exclude<EventType, 'visits' | 'all'>;
